import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';

const FastTrackSection: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        backgroundColor: '#F1F7FB',
        position: 'relative',
        overflow: 'hidden',
        backgroundImage:
          'url("https://dprstorage.b-cdn.net/RW/trackcareerimage.png")',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* SVG image below the title content */}
      <Box mb={8}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
            width: isMobile ? '94%' : '70%',
            height: 'auto',
            mx: 'auto',
          }}
        >
          <img
            src="https://dprstorage.b-cdn.net/RW/semicircle.png"
            alt="Semicircle decorative illustration"
            loading="lazy"
            decoding="async"
            style={{ width: '100%', height: 'auto' }}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
            mt: 8,
          }}
        >
          {!isMobile ? (
            <img
              src="https://dprstorage.b-cdn.net/RW/flowchhart1.png"
              alt="Career flowchart desktop"
              loading="lazy"
              decoding="async"
              style={{ width: '80%', height: 'auto' }}
            />
          ) : (
            <img
              src="https://dprstorage.b-cdn.net/RW/mobileviewflowchart.png"
              alt="Career flowchart mobile"
              loading="lazy"
              decoding="async"
              style={{ width: '95%', height: 'auto' }}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default FastTrackSection;
